import React, { useState } from "react";

const STATUSES = ["new", "pitched", "in_progress", "completed", "dismissed"];

export default function RecommendationCard({ reco, onStatusChange, showClient }) {
  const [status, setStatus] = useState(reco.status);
  const [saving, setSaving] = useState(false);
  const [notes, setNotes] = useState(reco.status_notes || "");

  async function save(nextStatus, nextNotes) {
    if (!onStatusChange) return;
    setSaving(true);
    try {
      await onStatusChange(reco.id, { status: nextStatus, status_notes: nextNotes });
      setStatus(nextStatus);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="reco">
      <h4>{reco.title}</h4>
      <div className="meta">
        <span className={`tag ${reco.priority}`}>{reco.priority}</span>
        <span className="tag">{reco.category}</span>
        {reco.estimated_revenue_usd ? (
          <span className="tag pill-accent">~${reco.estimated_revenue_usd.toLocaleString()}</span>
        ) : null}
        {showClient && reco.client_name && (
          <span className="tag">{reco.client_name}</span>
        )}
      </div>
      {reco.description && <div className="body">{reco.description}</div>}
      {reco.estimated_impact && (
        <div className="body" style={{ marginTop: 8 }}>
          <em>Impact:</em> {reco.estimated_impact}
        </div>
      )}
      {onStatusChange && (
        <div className="status-bar">
          <label style={{ display: "inline", marginRight: 6 }}>Status</label>
          <select
            value={status}
            onChange={(e) => save(e.target.value, notes)}
            disabled={saving}
          >
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <input
            style={{ flex: 1, marginLeft: 8 }}
            placeholder="Notes (optional)"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            onBlur={() => notes !== (reco.status_notes || "") && save(status, notes)}
          />
        </div>
      )}
    </div>
  );
}
